import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { EnvironmentService } from '@core/services/environment.service';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';

@Component({
    selector: 'app-cookie-consent-modal',
    standalone: true,
    imports: [NgClass, CtaButtonComponent],
    templateUrl: './cookie-consent-modal.component.html',
    styleUrls: ['./cookie-consent-modal.component.css'],
})
export class CookieConsentModalComponent {
    private environmentService = inject(EnvironmentService);
    private cd = inject(ChangeDetectorRef);
    private cookieConsentService = inject(CookieConsentService);

    active = toSignal(this.cookieConsentService.showConsentModal);
    animate = computed(
        () => this.active() && this.environmentService.isBrowser()
    );

    accept() {
        this.cookieConsentService.accept();
    }

    decline() {
        this.cookieConsentService.decline();
    }
}
